"use client";

import { useParams } from "next/navigation";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminUserRoleUpdate, UserRoles } from "@/entities";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  role: string;
  depository_id: number | null;
}
export default function UserEditRoleModal({
  isOpen,
  onClose,
  role,
  depository_id,
}: Props) {
  const params = useParams<{ id: string }>();

  const id = params?.id || "";

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
  } = useForm({
    defaultValues: {
      role,
      depository_id: depository_id || undefined,
    },
  });

  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: adminUserRoleUpdate,
    onSuccess: () => {
      toast.success("권한이 변경되었습니다.");
      queryClient.invalidateQueries({ queryKey: ["admin-user", id] });
      onClose();
    },
    onError: () => {
      toast.error("다시 시도해주세요");
    },
  });
  const onSubmit = async (data: any) => {
    if (updateMutation.isPending) return;

    await updateMutation.mutateAsync({
      id,
      role: data.role,
    });

    setValue("role", "");
    setValue("depository_id", undefined);
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalHeader toggle={onClose}>권한 변경</ModalHeader>
        <ModalBody className="p-0">
          <div className="form-horizontal form-bordered">
            <Controller
              name="role"
              control={control}
              rules={{
                required: "권한을 선택해주세요.",
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <div className="form-group row">
                  <label className="col-form-label col-md-3">권한</label>
                  <div className="col-md-9">
                    <select
                      className="form-select"
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                    >
                      {UserRoles.map((item, index) => {
                        return (
                          <option key={index} value={item.key}>
                            {item.value}
                          </option>
                        );
                      })}
                    </select>
                    {errors.role && (
                      <span className="text-red errorText">
                        {errors.role.message}
                      </span>
                    )}
                  </div>
                </div>
              )}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button type="submit" className="btn btn-sm btn-inverse">
            <i className="fa fa-check"></i>
            <span> 저장</span>
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
